<div class="password-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          Cambiar <span *ngIf="!resetPassword">mi</span> Contraseña
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row">
          <div class="col-md-12 password-group" *ngIf="!resetPassword">
            <mat-form-field appearance="outline">
              <input matInput name="oldPassword" formControlName="oldPassword" placeholder="Contraseña Actual"
                type="password" [ngClass]="{ 'is-invalid': submitted && f['oldPassword'].errors }" #oldPasswordInput>
            </mat-form-field>
            <mat-error *ngIf="submitted && f['oldPassword']?.errors?.['required']">
              Contraseña Actual Obligatoria
            </mat-error>
            <mat-error *ngIf="f['oldPassword'].hasError('minlength')">
              Contraseña muy corta, 6 caracteres mínimo.
            </mat-error>
            <i class="material-icons password-eye cursor-pointer" [ngClass]="viewOldPassword ? 'text-manax' : ''"
              (click)="toggleOldPasswordView()">visibility</i>
          </div>

          <div class="col-md-12 password-group">
            <mat-form-field appearance="outline">
              <input matInput name="newPassword" formControlName="newPassword" placeholder="Contraseña Nueva"
                type="password" [ngClass]="{ 'is-invalid': submitted && f['newPassword'].errors }" #newPasswordInput>
            </mat-form-field>
            <mat-error *ngIf="submitted && f['newPassword']?.errors?.['required']">
              Contraseña Nueva Obligatoria
            </mat-error>
            <mat-error *ngIf="f['newPassword'].hasError('minlength')">
              Contraseña muy corta, 6 caracteres mínimo.
            </mat-error>
            <mat-error *ngIf="f['newPassword'].hasError('invalidPassword')">
              Contraseña debe tener al menos 1 Mayúscula, 1 Minuscula y 1 número.
            </mat-error>
            <i class="material-icons password-eye cursor-pointer" [ngClass]="viewNewPassword ? 'text-manax' : ''"
              (click)="toggleNewPasswordView()">visibility</i>
          </div>

          <div class="col-md-12 password-group">
            <mat-form-field appearance="outline">
              <input matInput name="repeatPassword" formControlName="repeatPassword"
                placeholder="Repetir Contraseña Nueva" type="password" #repeatPasswordInput
                [ngClass]="{ 'is-invalid': submitted && f['repeatPassword'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['repeatPassword']?.errors?.['required']">
              Repetir Contraseña Nueva Obligatoria
            </mat-error>
            <mat-error *ngIf="f['repeatPassword'].hasError('mismatchedPasswords')">
              Las contraseñas no coinciden
            </mat-error>
            <i class="material-icons password-eye cursor-pointer" [ngClass]="viewRepeatPassword ? 'text-manax' : ''"
              (click)="toggleRepeatPasswordView()">visibility</i>
          </div>
        </div>

        <div class="row">
          <div class="col-12 pt-4">
            <button mat-raised-button type="submit" class="m-0 ml-1 pull-right btn btn-manax">
              Aceptar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link"
              (click)="dialog.close(false)">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>